import { render } from "./WorkflowsView.vue?vue&type=template&id=96e9ab72&scoped=true"
import script from "./WorkflowsView.vue?vue&type=script&lang=js"
export * from "./WorkflowsView.vue?vue&type=script&lang=js"

import "./WorkflowsView.vue?vue&type=style&index=0&id=96e9ab72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e9ab72"]])

export default __exports__